import moment from 'moment'
import { countdownTime } from '../../../utils/constants'

export const getTimestampDiff = (timestamp: number): number =>
  moment().diff(moment.unix(timestamp), 's')

export const isMoreThanCountdownAgo = (timestamp: number): boolean =>
  getTimestampDiff(timestamp) >= countdownTime
